




























import VueOptions from '@utils/VueOptions'
import WorkflowProgressBar from '@ui/ProgressBars/WorkflowProgressBar'

settings =
  name: 'ProgressBarsWindow'

  vue:
    components: { WorkflowProgressBar }

    data: ->
      showProgressBars: true
      time: null

    beforeDestroy: ->
      @stopPollTimer()

    computed:
      progressBars: -> @getAppSession('progress_bars', []) || []

    methods:
      startPollTimer: -> @time ||= setInterval(@fetchProgressBars, 1000 * 90)

      stopPollTimer: -> clearInterval(@time)

    watch:
      progressBars: ->
        if @progressBars.length
          @startPollTimer()
        else
          @stopPollTimer()

export default VueOptions.vue settings
